import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";

export default function StudentPracticeList() {
  const [sets, setSets] = useState([]);
  const [attempts, setAttempts] = useState([]);
  const [loading, setLoading] = useState(true);

  const nav = useNavigate();

  useEffect(() => {
    loadAll();
  }, []);

  const loadAll = async () => {
    try {
      setLoading(true);

      const [setsRes, attemptsRes] = await Promise.all([
        api.get("/quiz/available_practice_sets"),
        api.get("/quiz/student/practice/attempts"),
      ]);

      setSets(Array.isArray(setsRes.data) ? setsRes.data : []);
      setAttempts(Array.isArray(attemptsRes.data) ? attemptsRes.data : []);
    } catch (err) {
      console.error("Failed to load practice data", err);
      setSets([]);
      setAttempts([]);
    } finally {
      setLoading(false);
    }
  };

  const startSet = async (setId) => {
    try {
      nav(`/student/practice/take/${setId}`);
    } catch (err) {
      console.error("Failed to start practice", err);
      alert("Unable to start practice");
    }
  };

  if (loading) {
    return <p style={{ padding: 30 }}>⏳ Loading practice sets...</p>;
  }

  return (
    <div style={{ padding: 30 }}>
      <h2>🧠 Practice Sets</h2>

      {sets.length === 0 ? (
        <p>No practice sets available.</p>
      ) : (
        <table border="1" cellPadding="10" width="100%">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Questions</th>
              <th>Duration</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {sets.map((s, idx) => (
              <tr key={s.id}>
                <td>{idx + 1}</td>
                <td>{s.name}</td>
                <td>{s.num_questions}</td>
                <td>{s.duration_minutes} min</td>
                <td>
                  <button onClick={() => startSet(s.id)}>
                    ▶ Start
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <h3 style={{ marginTop: 40 }}>📊 My Attempts</h3>

      {attempts.length === 0 ? (
        <p>No attempts yet.</p>
      ) : (
        <ul>
          {attempts.map((a, i) => (
            <li key={a.attempt_id} style={{ marginBottom: 10 }}>
              Attempt {i + 1} — Score: {a.score}/{a.total_questions} (
              {a.percentage}%)
              <button
                style={{ marginLeft: 10 }}
                onClick={() =>
                  nav("/student/practice/result", {
                    state: { attemptId: a.attempt_id }
                  })
                }
              >
                View Result
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

/* ================= BACKGROUND ================= */
const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const overlayStyle = {
  minHeight: "100vh",
  backgroundColor: "rgba(0,0,0,0.25)",
  padding: 20,
};

/* ================= CARD ================= */
const cardWrapper = {
  maxWidth: 1100,
  margin: "auto",
  background: "rgba(255,255,255,0.95)",
  borderRadius: 16,
  padding: 30,
};

/* ================= HEADER ================= */
const headerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 10,
  marginBottom: 20,
};

const logoStyle = {
  width: 120,
};

const titleStyle = {
  fontSize: 20,
  fontWeight: 800,
};

const backBtn = {
  padding: "8px 14px",
  background: "#e2e8f0",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
};

/* ================= TABLE ================= */
const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginTop: 10,
};

const th = {
  border: "1px solid #ddd",
  padding: 10,
  textAlign: "left",
  fontWeight: 700,
};

const td = {
  border: "1px solid #ddd",
  padding: 10,
  verticalAlign: "top",
};

/* ================= EXTRA ================= */
const attemptBox = {
  borderBottom: "1px dashed #ddd",
  marginBottom: 8,
  paddingBottom: 8,
};

const startBtn = {
  padding: "6px 14px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
};

const smallBtn = {
  fontSize: 12,
  marginTop: 6,
  padding: "4px 10px",
  background: "#e5e7eb",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
};
